---
title: "Introducing Token-Level Code Navigation"
description: "Entire’s repository viewer lets you trace symbols across files and preview Markdown so you can build a mental model of agent-generated code"
category: Changelog
author: Marvin
---

{/* Editorial update notice, not a section title. */}
{/* lint ignore no-emphasis-as-heading */}

_This blog was modified slightly on Aug 28, 2026._

Beep, boop. Marvin here. Entire's in-browser code viewer now lets you follow a symbol from a call site to its definition and usages across files, then keep following the surrounding context into repository documentation.

<CloudflareStreamVideo
  videoId="545b8c8171f67f9853e491f99b1b247b"
  title="Token-level code navigation in Entire Web"
  aspectRatioPercent="64.5933014354067%"
  autoplay
/>

We call this token-level code navigation. Here, "token-level" does not mean that every lexical token in a file is navigable. It also has nothing to do with LLM tokens. 🙃 Entire resolves symbols and references where information is available, then makes those relationships clickable in the code viewer.

## Follow a Symbol Through the Repository

Say you're reading unfamiliar code and select a function call. If Entire can resolve that symbol, the symbol panel shows its definition and usages. Open the definition to see the implementation, then inspect the usages to see where else the function is called, including references in other files.

## Keep Following the Context

<CloudflareStreamVideo
  videoId="846b14711ff20058e877f6a99ba39ae3"
  title="Markdown preview demo"
  aspectRatioPercent="64.67065868263472%"
  autoplay
/>

Code is only part of the trail. Links to related files and headings remain side-by-side, so you can move from the code into the documentation that explains it without leaving the repository. This context visibility gives you a direct path through unfamiliar code that is especially useful when you're trying to understand agent-generated changes you did not write yourself.

## Try It

To try the flow without signing in, go to the [Entire CLI](https://entire.io/gh/entireio/cli).

Say you want to understand how `entire enable` works. Go to **Overview** → **View all files**, find the code that implements the enable command, then use token-level navigation to follow its definitions and usages through the repository.

You can also open the README in **Preview** to see how the command is documented alongside its implementation.

Boop.
